import { render, staticRenderFns } from "./blacklistCar.vue?vue&type=template&id=53360abd&scoped=true&"
import script from "./blacklistCar.vue?vue&type=script&lang=js&"
export * from "./blacklistCar.vue?vue&type=script&lang=js&"
import style0 from "./blacklistCar.vue?vue&type=style&index=0&id=53360abd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53360abd",
  null
  
)

export default component.exports